// src/app/services/performance-series/source-setting-api.ts
//
// Client for the GLOBAL, admin-controlled Performance data-source toggle. The
// value lives on the backend (app_config), not in a frontend env file — an
// admin flips the whole platform from one place and every client reads the
// current value at runtime.
//
//   GET  /analytics/series-source   → { source }   (any authenticated user)
//   PUT  /analytics/series-source   → { source }   (admin only)

import { apiFetch } from "@/api/api-fetch";

export type SeriesSourceMode = "fixture" | "api";

function coerce(raw: unknown): SeriesSourceMode {
  return String((raw as any)?.source ?? raw ?? "").toLowerCase() === "api"
    ? "api"
    : "fixture";
}

/** Read the current global source mode. Any authenticated user may read it. */
export async function fetchPerfSeriesSource(): Promise<SeriesSourceMode> {
  const res = await apiFetch<{ source: string }>("/analytics/series-source");
  return coerce(res);
}

/** Set the global source mode. Admin only (backend enforces 403 otherwise). */
export async function updatePerfSeriesSource(
  source: SeriesSourceMode,
): Promise<SeriesSourceMode> {
  const res = await apiFetch<{ source: string }>("/analytics/series-source", {
    method: "PUT",
    body: JSON.stringify({ source }),
  });
  return coerce(res);
}
